import { ScrollWidthService } from '$core/services/scroll-width.service';
import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-overlay',
  template: '<ng-content></ng-content>',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent {
  @HostBinding('style.right.px')
  public get scrollCompensation() {
    return this.scrollWidthService.scrollWidth;
  }

  constructor(private scrollWidthService: ScrollWidthService) {}
}
